'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  PUBLISHING: null,
  HISTORY: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/constants/PubNubMessageGroups.js
// module id = 161
// module chunks = 0 1